/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Name and email address for reply to. This is used for email notification.
 */
export interface MessageReplyTo { 
    /**
     * Email id for \'reply to\'. Default value \'donotreply@vmware.com\'.
     */
    email?: string;
    /**
     * Name in the email for \'reply to\'. Default value \'VMware\'.
     */
    name?: string;
}

